import axios from 'axios';

const api = axios.create({
  baseURL: 'https://app.todowebsmart.it/api',  // Update with the correct API URL
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add an interceptor for requests
api.interceptors.request.use(
  config => {
    // Add authorization header if token exists
    const token = localStorage.getItem('token');
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

export default api;
